var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[(_vm.loaded)?_c('div',{staticClass:"tableContainer"},[_c('p',[_vm._v(_vm._s(_vm.$t('stations')))]),_vm._v(" "),_c('GeoJsonTreeLocation',{attrs:{"tree-locations":true,"enable-stations":false}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }